'use strict';

const page = require('../../page'),
    navigation = require('../../navigation'),
    ajaxUrl = require('../../modules/util/ajaxUrl'),
    Promise = require('promise'),
    bonusProductsView = require('../../bonus-products-view'),
    certificateView = require('../../certificate-view'),
    gtm = require('../../modules/google').tagManager,
    dialog = require('../../dialog'),
    scrollHelper = require('../../modules/helpers/scroll'),
    outOfStock = require('../product/outOfStock'),
    pglightbox = require('../personalisedgifting/lightbox'),
    pgCartUtils = require('../personalisedgifting/pgCartUtils'),
    variations = require('./variations');

/**
 * @description Make the AJAX request to add an item to cart
 * @param {Element} form The form element that contains the item quantity and ID data
 * @returns {Promise}
 */
const addItemToCart = function (form, eventData) {
    const $form = $(form);
    let $qty = $form.find('input[name="Quantity"]');
    const dataLayerProduct = $form.find('input[name="dataLayerProduct"]').length > 0 ? JSON.parse($form.find('input[name="dataLayerProduct"]').val()) : null;

    if ($qty.length === 0 || isNaN($qty.val()) || parseInt($qty.val(), 10) === 0 || $qty.val() < 0) {
        if ($qty.length === 0){
            $qty = $('<input type="hidden" name="Quantity"/>');
        }
        $qty.val('1');
    } else if (parseInt($qty.val()) > 999) {
        $qty.val(999);
    }

    return Promise.resolve($.ajax({
        type: 'POST',
        url: ajaxUrl(Urls.addProduct),
        data: $form.serialize()
    })).then(function (response) {
        // handle error in the response
        if (response.error) {
            throw new Error(response.error);
        }
        if (response.replaceGiftSet){
            pgCartUtils.showReplacePGDialog();
            return false;
        }
        if (eventData && eventData.eventName) {
            const productPosition = $form.closest('.product-list-slider-item').data('counter');
            gtm.updateQuantity(
                eventData.eventName,
                dataLayerProduct,
                parseInt($qty.val(), 10),
                productPosition);

            // close quickview dialog if product added from quickview
            // which is actually a variant selection from the cop
            if (eventData.isQuickView){
                $('.js-popup-generic').dialog('close');
            }
        }

        return response;
    });
};

/**
 * @description Handler to handle the add to cart event
 */
const addToCart = function (e) {
    e.preventDefault();
    // stop propagation (in case it's a linked product tile)
    e.stopPropagation();

    const $target = $(e.target);
    const $form = $target.closest('form');

    pglightbox.ensureFinalProductIdIsSet($form);

    const eventData = {
        isQuickView: $target.hasClass('js-add-to-cart-quickview'),
        eventName: $target.data('addtocart-event')
    };

    addItemToCart($form, eventData).then(function (response) {
        if (!response) {
            return;
        }

        const $uuid = $form.find('input[name="uuid"]');
        if (($uuid.length > 0 && $uuid.val().length > 0) || pageContext.type === 'Cart') {
            page.refresh();
            return;
        }

        // if add to cart button is in sticky bar
        const ctaAddToCartBtn = $target.closest('.js-sticky-add-to-cart').length > 0;

        const $thumbnailImage = $form.find('input[name="thumbnailImage"]');
        if ($thumbnailImage.length){
            $('.js-product-image-mobile').attr('data-src', $thumbnailImage.val());
        } else {
            pgCartUtils.handleMobileMinicartImage($form, response);
        }

        const discountDataElement = $(response).find('.js-minicart-discount-data');
        if (discountDataElement.length) {
            const addedProductId = discountDataElement.data('added-product-id');
            displayCRMChoiceModule(discountDataElement, addedProductId, response, false);
        } else {
            updateMiniCartOnAddProduct(response, false);
        }

        navigation.initNavigationToMainSite(); // for fastlane sites there is to-home link at the bottom of minicart same as in header
        const cartIsEmpty = false;
        navigation.updateNavigationLinksOnAddToCart(cartIsEmpty);

        // add checkmark on a click
        if ($('.js-sticky-add-to-cart').length) {
            if (ctaAddToCartBtn) {
                $('.js-sticky-add-to-cart .js-add-to-cart').addClass('checked');
                setTimeout(function() {
                    $('.js-sticky-add-to-cart .js-add-to-cart').removeClass('checked');
                }, 4000);
            }
        }
    }.bind(this));
};

function displayCRMChoiceModule(discountDataElement, addedProductId, response, hideMinicart) {
    const url = discountDataElement.data('choice-discount-url');
    const productID = discountDataElement.data('choice-selected-product').toString();
    bonusProductsView.show({
        url: url,
        giftChange: true,
        response: true,
        selectedID: productID,
        addedProductId: addedProductId,
        onClose: function() {
            updateMiniCartOnAddProduct(response, hideMinicart);
        }
    });
}

function updateMiniCartOnAddProduct(response, hideMinicart) {
    const nonSelectedGiftLink = $($.parseHTML(response)).find('.bonus-item-actions a.js-select-bonus-product').first();
    let url = null;
    let showAdded = false;

    if (nonSelectedGiftLink && nonSelectedGiftLink.length > 0) {
        url = nonSelectedGiftLink.attr('href');
        showAdded = nonSelectedGiftLink.data('showadded');
    }
    const displayGwpToast = $(response).find('input[name=DisplayGwpToast]').val() === 'true';
    const showToastNotificationOnFirstAdd = $(response).find('input[name=ShowToastNotificationOnFirstAdd]').val() === 'true';

    bonusProductsView.show({
        url: url,
        giftChange: false,
        response: response,
        isAddedPopup: showAdded,
        displayGwpToast: displayGwpToast || showToastNotificationOnFirstAdd
    }, hideMinicart);

    const cartEl = document.querySelector('.js-shopping-circle');
    cartEl.classList.add('cart-number-show');
}

/**
* @description adjust the quantity
*/
const quantityButtons = function(e){
    e.preventDefault();
    const qInput = $('input[id$=Quantity]');
    const currentAmount = qInput.val() * 1;
    qInput.val($(this).attr('data-count') != '-' ? (currentAmount < 999 ? currentAmount + 1 : 999) : (currentAmount > 1 ? currentAmount - 1 : 1));
};

/**
 * @description check quantity limits
 */
const checkQuantityLimits = function (e) {
    e.preventDefault();

    const qInput = $('input[id$=Quantity]');
    const currentValue = qInput.val();
    if (isNaN(currentValue) || currentValue < 0) {
        qInput.val(1);
    } else if (parseInt(currentValue) >= 999) {
        qInput.val(999);
    }
};

/**
 * @function
 * @description check quantity limits
 */
const openQuickviewFromContent = function (e) {
    const $this = $(this);
    // prevent default behaviour
    e.preventDefault();
    // prevent event bubbling
    e.stopPropagation();
    dialog.open({
        url: $this.attr('href') || $this.data('href'),
        source: 'quickview',
        target: $('.js-popup-generic'),
        options: {
            closeOnEscape: true,
            dialogClass: 'popup-generic-holder',
            width: '640',
            autoOpen: true,
            create: function() {
                // lock body scroll
                scrollHelper.disableScroll();

                $('.js-modal-overlay').show();

                $('body').on('click touchstart', '.js-modal-overlay', function(){
                    dialog.close();
                });

            },
            beforeClose: function() {
                scrollHelper.enableScroll();
                $('.js-modal-overlay').hide();
                $('.js-popup-generic').empty();
            },
            position: {
                my: 'center',
                at: 'center',
                of: window,
                collision: 'flipfit'
            }
        }
    });

    // lock body scroll
    scrollHelper.disableScroll();

    $('.js-modal-overlay').show();
    $('.popup-generic-holder').focus();
};

function showCertificatePopup(event) {
    event.preventDefault();
    event.stopPropagation();
    certificateView.show({addToCartButton: event.target});
}

const pushDataLayerEventEaster = () => {
    const $divWrapper = $('.product-add-to-cart');
    const analyticsData = $divWrapper.find('input[name="analyticsData"]').attr('value');
    if (!analyticsData) {
        return;
    }
    const analytics = JSON.parse(analyticsData);
    analytics.event_label = $('.js-the-ritual-of-title').first().text().trim(); /* eslint-disable-line camelcase */
    gtm.pushDataLayerEvent(analytics);
};

function pushDataLayerEventAdvent(event) {
    const form = $(event).closest('form');
    pglightbox.ensureFinalProductIdIsSet(form);
    const values = form[0][6].defaultValue;
    const product = JSON.parse(values);
    const current = $(event).closest('.advent-comparison-item')[0];
    if (!current) {
        return;
    }

    gtm.pushDataLayerEvent({
        event: 'advent',
        ecommerce: {
            currencyCode: current.attributes['data-currency-code'].value,
            add: {
                products: [{
                    name: product.name,
                    id: product.sku,
                    price: current.attributes['data-product-price'].value
                }]
            }
        }
    });
}

/**
 * @function
 * @description Binds the click event to a given target for the add-to-cart handling
 */
module.exports = {
    init: function () {
        outOfStock.init();
        pgCartUtils.init();

        $('.js-add-to-cart[disabled]').attr('title', $('.availability-msg').text());

        $(document).on('click', '.js-add-to-cart, .js-add-to-cart-quickview', function(e, skipCertificateForm) {
            const addToCartButton = $(e.target);
            if (addToCartButton.hasClass('js-variations-add-to-cart')){
                const valid = variations.validateVariations(e);
                if (!valid) {
                    return;
                }
                pushDataLayerEventEaster();
            }

            if (!skipCertificateForm && addToCartButton.hasClass('js-add-to-cart-talisman')) {
                showCertificatePopup(e);
                return;
            }

            if (document.querySelector('.js-advent-block')) {
                pushDataLayerEventAdvent(e.target);
            }

            addToCart(e);
        });

        $(document).on('click','.js-quantity-button', quantityButtons);

        /* Quantity input field event */
        $(document).on('blur','input[id$=Quantity]', checkQuantityLimits);

        $(document).on('click', '.js-open-quickview', openQuickviewFromContent);
    },
    updateMiniCartOnAddProduct: updateMiniCartOnAddProduct
};
